/**
 * Локальная Сека с ботами: синтетический SessionOutcomeEvent для UI (без записи на сервер).
 * Политика респекта совпадает с server/src/game/respectProgression.js (calcRespectReward).
 */

import {
  applyRespectDelta,
  calcRespectReward,
  cumulativeRespectPoints,
  detectUnlockedMilestones,
  normalizeProgress,
} from './respectProgression';

function respectDeltaForLocal(outcomeKind, botCount) {
  if (outcomeKind === 'chop') return 0;
  return calcRespectReward({
    game: 'seka',
    didWin: outcomeKind === 'win',
    hasBots: Math.max(0, Number(botCount) || 0) >= 1,
    isOnline: false,
  });
}

/**
 * @param {{
 *   user: { id?: string, level?: number, xpCurrent?: number, bucksBalance?: number } | null,
 *   outcomeKind: 'win'|'lose'|'chop',
 *   botCount: number,
 *   userBalance: number,
 *   heroTableChips: number,
 *   sekaDelta: number|null,
 *   handKey: string,
 * }} p
 */
export function buildLocalSekaBotSessionOutcome(p) {
  const user = p.user;
  const outcomeKind = p.outcomeKind;
  const botCount = Math.max(0, Math.floor(Number(p.botCount) || 0));
  const userBalance = Math.max(0, Math.floor(Number(p.userBalance) || 0));
  const heroTableChips = Math.max(0, Math.floor(Number(p.heroTableChips) || 0));
  const bucksAfter = Math.max(0, Math.floor(Number(user?.bucksBalance) || 0));
  const sekaDelta = p.sekaDelta != null && Number.isFinite(Number(p.sekaDelta)) ? Math.trunc(Number(p.sekaDelta)) : 0;
  const respectDelta = respectDeltaForLocal(outcomeKind, botCount);

  const levelRaw = user?.level;
  const xpRaw = user?.xpCurrent;
  const progressBefore = normalizeProgress(levelRaw, xpRaw);
  const afterRaw =
    respectDelta === 0
      ? progressBefore
      : applyRespectDelta(progressBefore.level, progressBefore.xpCurrent, respectDelta);
  const progressAfter =
    respectDelta === 0
      ? progressBefore
      : {
          level: afterRaw.level,
          xpCurrent: afterRaw.xpCurrent,
          xpMax: afterRaw.xpMax,
          rankName: afterRaw.rankName,
        };

  const result = outcomeKind === 'chop' ? 'draw' : outcomeKind;
  const displayStyle = outcomeKind === 'win' ? 'victory' : outcomeKind === 'lose' ? 'defeat' : 'neutral';

  const prevCum = cumulativeRespectPoints(progressBefore.level, progressBefore.xpCurrent);
  const nextCum = cumulativeRespectPoints(progressAfter.level, progressAfter.xpCurrent);
  const unlocked = detectUnlockedMilestones(prevCum, nextCum);

  return {
    outcomeId: `local-seka:${String(p.handKey || '').trim()}`,
    game: 'seka',
    mode: 'local',
    userId: String(user?.id != null ? user.id : 'guest'),
    result,
    respectDelta,
    respectGain: respectDelta,
    currencyDelta: { seka: sekaDelta, bucks: 0 },
    balanceAfter: {
      seka: userBalance,
      bucks: bucksAfter,
    },
    heroTableChips,
    progressBefore: {
      level: progressBefore.level,
      xpCurrent: progressBefore.xpCurrent,
      xpMax: progressBefore.xpMax,
      rankName: progressBefore.rankName,
    },
    progress: {
      level: progressAfter.level,
      xpCurrent: progressAfter.xpCurrent,
      xpMax: progressAfter.xpMax,
      rankName: progressAfter.rankName,
    },
    road: {
      previousScore: prevCum,
      currentScore: nextCum,
      unlockedMilestones: unlocked,
    },
    display: { durationMs: 3000, style: displayStyle },
    at: Date.now(),
  };
}
